import Vue from 'vue'
import Router from 'vue-router'

import store from './store'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/',
			name: 'basket',
			component: () => import(/* webpackChunkName: "basket" */ '@/pages/BasketPage.vue'),
		}, {
			path: '/landing',
			name: 'landing',
			component: () => import(/* webpackChunkName: "landing" */ '@/pages/LandingPage.vue'),
		}, {
			path: '/add/:ids',
			name: 'add-product',
			beforeEnter(to, from, next) {
				const { ids } = to.params
				for (var p of splitIds(ids)) {
					store.dispatch('addProduct', p) // p == { id, count }
				}
				next({ name: 'basket' })
			},
		}, {
			// очищает корзину перед добавление товара
			path: '/pick/:id',
			name: 'pick-product',
			beforeEnter(to, from, next) {
				const { id } = to.params
				const count = 1
				store.dispatch('setProduct', { id, count })
				next({ name: 'basket' })
			},
		}, {
			path: '/404',
			component: () => import(/* webpackChunkName: "notfound" */ '@/pages/NotFoundPage.vue'),
		}, {
			path: '*',
			redirect: { name: 'basket' },
		},
	],
	scrollBehavior() {
		// скролл каждой страницы сверху
		return { x: 0, y: 0 }
	},
})

export default router

class Prod {
	id: string
	count: number
	constructor(s: Array<string>) {
		this.id = s[0]
		this.count = Number(s[1])
		if (isNaN(this.count)) this.count = 1
	}
}

function splitIds(ids: string): Array<Prod> {
	if (ids == null) return []
	return ids.split('+').map(it => new Prod(it.split(':')))
}
